import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { styled } from '@mui/material/styles';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Switch,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
} from '@mui/material';
// components
import Label from '../components/label';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
// sections
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';
import DevicesPage from './DevicesPage';
import HunterForDog from '../components/HunterForDog';

const styles = { 
  narrowCell: {
    'width': '150px',
  }
};

const TABLE_HEAD = [
  { id: 'id', label: 'Broj', alignRight: false },
  { id: 'subscriber', label: 'Vlasnik', alignRight: false },
  { id: 'ime', label: 'Ime', alignRight: false },
  { id: 'tiptrackera', label: 'Tip trackera', alignRight: false },
  { id: 'IMEI', label: 'IMEI', alignRight: false },
  { id: 'aktivan', label: 'Aktivan', alignRight: false },
  { id: 'online', label: 'Online', alignRight: false },
  { id: 'onlinetoday', label: 'Online danas', alignRight: false },
  { id: 'datumlast', label: 'Datum last', alignRight: false },
  { id: 'datumend', label: 'Datum end', alignRight: false },
  { id: 'saldo', label: 'Saldo', alignRight: false },
  { id: 'update', label: 'Update', alignRight: false },
  { id: 'share', label: 'Share', alignRight: false },
  { id: 'transfer', label: 'Transfer', alignRight: false },
  { id: 'delete', label: 'Delete', alignRight: false }
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.ime.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

  function useForceUpdate() {
    const [value, setValue] = useState(0); // integer state
    return () => setValue(value => value + 1); // update state to force render
    // A function that increment 👆🏻 the previous state like here 
    // is better than directly setting `setValue(value + 1)`
  }

export default function ClanKerovi(props) {
	
  const navigate  = useNavigate();

  const [isopen, setIsOpen] = useState(false);
  
  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');
  
  const [members, setMembers] = useState([]);
  
  const [id, setId] = useState(0);
  
  const [deviceid, setDeviceId] = useState(0);
  
  const [dataloaded, setDataLoaded] = useState(false);

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('id');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(10);
  
  const [showdogcreate, setShowDogCreate] = useState('');
  
  const forceUpdate = useForceUpdate();
  
  const SERVER_URL = process.env.REACT_APP_BACKEND_SERVER_URL;
  
  useEffect(() => {    // Update the document title using the browser API    
	//refreshData();
  });
  
  const handleChange = (event, id) => {
	 	
    var array = members;
	
	const objectWithSpecificId = array.find(
		obj => obj.id === id
	);
	
	axios.put("https://gpsdogstracking.com:3000/api/devices/" + id,
		{
		"aktivan": !objectWithSpecificId.aktivan
		}
	).then(() => {
		// getAllHunters();
		objectWithSpecificId.aktivan = !objectWithSpecificId.aktivan;

		setMembers(array);
		forceUpdate(); 
	});
  };
  
  const handleRefresh = (event, id) => {  
	setShowDogCreate(!showdogcreate);
	refreshData();
  };
   
  function refreshData() {
  console.log(props.vlasnik);  
  const str1 = SERVER_URL + "/devices?subscriberId=";
  const str2 = str1.concat('', props.vlasnik);
  const url = str2;
  console.log(url);
		
  fetch(url)
    .then((res) => res.json())
      .then((json) => {
		setId(props.vlasnik);
        setMembers(json);
		setDataLoaded(true);
        console.log(json);
      });
  }
  
  if (id !== props.vlasnik)
	refreshData();

  const setData = (data) => {
  console.log(data);
  
  const { id, subscriberId, subscriber, ime, tip, IMEI, tiptrackera, brojmobitela, bojaputanje, uploadinterval, needreset, workmode, setuploadinterval, blokiran, datumstart, datumend, datumlast, brojlokacija } = data;
    
  localStorage.setItem('id', id);
  localStorage.setItem('subscriberId', subscriberId);
  localStorage.setItem('subscriberime', subscriber.ime);
  localStorage.setItem('subscriberprezime', subscriber.prezime);
  localStorage.setItem('subscribermjesto', subscriber.mjesto);
  localStorage.setItem('subscriberdrzava', subscriber.drzava);
  localStorage.setItem('ime', ime);  
  localStorage.setItem('tip', tip);
  localStorage.setItem('IMEI', IMEI);
  localStorage.setItem('tiptrackera', tiptrackera);
  localStorage.setItem('brojmobitela', brojmobitela);
  localStorage.setItem('bojaputanje', bojaputanje);
  localStorage.setItem('uploadinterval', uploadinterval);
  localStorage.setItem('needreset', needreset);
  localStorage.setItem('workmode', workmode);
  localStorage.setItem('setuploadinterval', setuploadinterval);
  localStorage.setItem('blokiran', blokiran);
  localStorage.setItem('datumstart', datumstart);
  localStorage.setItem('datumend', datumend);
  localStorage.setItem('datumlast', datumlast);
  localStorage.setItem('brojlokacija', brojlokacija);
  }
  
  const handleClickDelete = (event, id) => {
	console.log(id);
	setDeviceId(id);
	
	setIsOpen(true);
  };
  
  const handleClose = () => {
	console.log('Closing...');
    setIsOpen(false);
  };

  const handleNo = () => {
	console.log('Closing... No clicked.');
    setIsOpen(false);
  };
  
  const handleYes = () => {
	console.log("Deleting:" + deviceid);

	DeleteDevice(deviceid);
	
    setIsOpen(false);
  };
    
  const DeleteDevice = (deviceid) => {
  console.log(deviceid);  
		
  axios.delete(SERVER_URL + "/devices/" + deviceid, {}).then(() => {
    //navigate('/dashboard/HuntersReportAll')
	refreshData();
  })
  }
  
  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = members.map((n) => n.ime);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, ime) => {
    const selectedIndex = selected.indexOf(ime);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, ime);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - members.length) : 0;

  const filteredUsers = applySortFilter(members, getComparator(order, orderBy), filterName);

  const isNotFound = !filteredUsers.length && !!filterName;
  
  const Android12Switch = styled(Switch)(({ theme }) => ({
  padding: 8,
  '& .MuiSwitch-track': {
    borderRadius: 22 / 2,
    '&:before, &:after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      width: 16,
      height: 16,
    },
    '&:before': {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main),
      )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
      left: 12,
    },
    '&:after': {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main),
      )}" d="M19,13H5V11H19V13Z" /></svg>')`,
      right: 12,
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: 'none',
    width: 16,
    height: 16,
    margin: 2,
  },
  }));

  return (
    <>
      <Helmet>
        <title>  GPS Dogs Tracking System </title>
      </Helmet>
	  
	  <Dialog
        open={isopen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Brisanje uređaja
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Da li ste sigurni?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleNo}>Ne</Button>
          <Button onClick={handleYes} autoFocus>Da</Button>
        </DialogActions>
      </Dialog>

      <Container maxWidth="xl">
	  <Button onClick={() => setShowDogCreate(!showdogcreate)}>Dodaj uređaj</Button>	
	  {showdogcreate && <HunterForDog hunterId = {props.vlasnik} handler = {handleRefresh} className = "child"/>}	
	  
        <Card>
           {members.length > 0 ? <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
				  color='#000055'
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={members.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {members.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                    const { id, ime, tip, IMEI, tiptrackera, brojmobitela, aktivan, online, onlinetoday, blokiran, baterija, brojlokacija, datumend, saldo, datumlast, subscriber } = row;  
                    const selectedUser = selected.indexOf(ime) !== -1;

                    return (
					  <TableRow hover key={id} tabIndex={-1} role="checkbox" selected={selectedUser}>
					    <TableCell component="th" scope="row" >
						  <Typography variant="subtitle2" noWrap>
							{id}
                          </Typography>
                        </TableCell>
						
                        <TableCell component="th" scope="row" >
						  <Stack direction="row" alignItems="center" spacing={2}>
                            <Avatar alt={ime} src={"/assets/images/lovackipsi/" + tip + ".jpg"} sx={{ width: 50, height: 50 }} variant="rounded"/>
							<Avatar alt={ime} src={"/assets/images/trackers/" + tiptrackera + ".jpg"} sx={{ width: 30, height: 30 }} variant="rounded"/>
                          </Stack>
                        </TableCell>
						
						<TableCell align="left">
						<Typography variant="subtitle2" noWrap>
						{subscriber.ime} {subscriber.prezime}
						</Typography>
						</TableCell>
						
						<TableCell align="left">
						<Typography variant="subtitle2" noWrap>
						{ime}
						</Typography>
						</TableCell>
												
                        <TableCell align="left">
						<Typography variant="subtitle2" noWrap>
						{tiptrackera}
						</Typography>
						</TableCell>	

                        <TableCell align="left">
						<Typography variant="subtitle2" noWrap>
						{IMEI}
						</Typography>
						</TableCell>						
						
						<TableCell align="left">					
						<Checkbox
						color="success"
						checked={aktivan}
						onChange={(event) => handleChange(event, id)}
						inputProps={{ 'aria-label': 'controlled' }}
						/>
						</TableCell>
						
						<TableCell> 
						<FormControlLabel
							control={<Android12Switch defaultChecked  
							checked={Boolean(online)}
							//onChange={(event) => handleChange(event, id)}
						/>}
						/>
						</TableCell>
						
						<TableCell> 
						<FormControlLabel
							control={<Android12Switch defaultChecked  
							checked={Boolean(onlinetoday)}
							//onChange={(event) => handleChange(event, id)}
						/>}
						/>
						</TableCell>
						
                        <TableCell align="left">
						<Typography variant="subtitle2" noWrap>
						{datumlast}
						</Typography>
						</TableCell>
						
                        <TableCell align="left">
						<Typography variant="subtitle2" noWrap>
						{datumend}
						</Typography>
						</TableCell>
						
                        <TableCell align="left">
						<Typography variant="subtitle2" noWrap>
						{saldo}
						</Typography>
						</TableCell>
						
						<TableCell> 
						<Link to='/SLOBiHDogs/update'>
						<Button onClick={() => setData(row)}>Update</Button>
						</Link>
						</TableCell>
						
						<TableCell> 
						<Link to='/SLOBiHDogs/sharedevice'>
						<Button onClick={() => setData(row)}>Share</Button>
						</Link>
						</TableCell>
						
						<TableCell> 
						<Link to='/SLOBiHDogs/transferdevice'>
						<Button onClick={() => setData(row)}>Transfer</Button>
						</Link>
						</TableCell>
						
						<TableCell> 
						<Button onClick={(event) => handleClickDelete(event, id)}>Delete</Button>
						</TableCell>
																	
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>

                {isNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Paper
                          sx={{
                            textAlign: 'center',
                          }}
                        >
                          <Typography variant="h6" paragraph>
                            Not found
                          </Typography>

                          <Typography variant="body2">
                            No results found for &nbsp;
                            <strong>&quot;{filterName}&quot;</strong>.
                            <br /> Try checking for typos or using complete words.
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>
		  : <div><br /> Nema kerova </div>}
		  
        </Card>
      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem>
          <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
          Edit
        </MenuItem>

        <MenuItem sx={{ color: 'error.main' }}>
          <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
          Delete
        </MenuItem>
      </Popover>
    </>
  );
}
